import { Moods } from "@/types/moodsData";
import { SpaceData } from "@/types/spaceData";

export const getSpaceMoodAssetUrls = (spaceData?: SpaceData, mood?: Moods | any) => {
  const modelUrl = spaceData?.data?.modelUrl;
  const hdriUrl = mood?.sky?.hdriUrl;
  const skyUrl = mood?.sky?.skyImageUrl;
  const lightMapUrl = mood?.lightMap?.lightMapUrl;
  const clones = spaceData?.data?.clones || [];
  const materialOverrides = mood?.materialOverrides || [];

  return [
    modelUrl ? { url: `${modelUrl}`, kind: "model" as const, label: "space-model" } : null,
    hdriUrl ? { url: hdriUrl, kind: "hdr" as const, label: "mood-hdri" } : null,
    skyUrl ? { url: skyUrl, kind: "texture" as const, label: "sky-texture" } : null,
    lightMapUrl ? { url: lightMapUrl, kind: "texture" as const, label: "light-map" } : null,
    ...clones
      .filter((clone: any) => Boolean(clone?.modelUrl))
      .map((clone: any, index: number) => ({
        url: clone.modelUrl,
        kind: "model" as const,
        label: `space-clone-${index}`,
      })),
    ...materialOverrides
      .filter((override: any) => Boolean(override?.textureUrl))
      .map((override: any, index: number) => ({
        url: override.textureUrl,
        kind: "texture" as const,
        label: `material-override-${index}`,
      })),
  ].filter(Boolean);
};
